import React from 'react';
import { Typography, Paper, CircularProgress, List, ListItem, ListItemText, IconButton, Box } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const getFileNameFromUrl = (url) => {
  try {
    const decodedUrl = decodeURIComponent(url);
    return decodedUrl.split('/').pop();
  } catch (error) {
    return 'N/A';
  }
};

const RecentList = ({ title, items, type, loading, link }) => (
  <Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
      <Typography variant="h6">
        {title}
      </Typography>
      {link && (
        <IconButton
          size="small"
          onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
          title="Open in new tab"
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
    {loading ? (
      <CircularProgress size={24} />
    ) : items.length === 0 ? (
      <Typography color="text.secondary">No recent items</Typography>
    ) : (
      <List>
        {items.map((item) => (
          <ListItem key={item.id} sx={{ py: 0.5 }}>
            <ListItemText
              primary={
                type === 'document' 
                  ? getFileNameFromUrl(item.webUrl)
                  : item.fields?.Title1 || item.fields?.Title || 'Unnamed Record'
              }
              secondary={
                type === 'document'
                  ? item.lastModifiedDateTime 
                    ? new Date(item.lastModifiedDateTime).toLocaleDateString()
                    : 'N/A'
                  : item.fields?.field_3
                    ? new Date(item.fields.field_3).toLocaleDateString()
                    : 'N/A'
              }
              primaryTypographyProps={{
                variant: 'body2',
                noWrap: true
              }}
              secondaryTypographyProps={{
                variant: 'caption',
                color: 'text.secondary'
              }}
            />
          </ListItem>
        ))}
      </List>
    )}
  </Paper>
);

export default RecentList; 